<lf-plaid-link
    #plaidLink
    [userWorkflow]="this.context === 'user'"
></lf-plaid-link>
